// Copyright (c) 2019-2020 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'

import MenuItem from '..'

import ContactSupportOutlinedIcon from '@material-ui/icons/ContactSupportOutlined'

class StreamMark extends Component {

  render () {
    return (
      <MenuItem
        title='Product Details'
        buttonText={<><ContactSupportOutlinedIcon />Contact our sales team</>}
        href={'https://www.verimatrix.com/online-contact-form'}
      >
        <div className='stream-mark product-details'>
          <div className='row title'>
            <p>Watermarking delivers client- and server-side protection of live, linear and on-demand video</p>
          </div>
          <div className='row text'>
            <ul>
              <li className='lh'>{'Stream Mark key features include:'}</li>
              <li>{'Forensic watermarking for premium linear, on-demand and ABR services'}</li>
              <li>{'Imperceptible for premium VOD content, such as UHD Robust against multiple attack types, including compression, recording/capturing, re-streaming, collision, geometric manipulation'}</li>
              <li>{'Payload extraction possible from low-grade and mixed-source content '}</li>
              <li>{'Independent of video player and content distribution network'}</li>
              <li>{'Rapid identification and shutdown of the illicit stream source, such as live sports'}</li>
              <li>{'Opaque system with no personally identifiable data in video '}</li>
              <li>{'Cloud-based Reveal Service works with blind extraction'}</li>
            </ul>
          </div>
        </div>
      </MenuItem>
    )
  }
}

export default (StreamMark)
